import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, LinearProgress } from '@material-ui/core';
import SportList from '../../../Components/ManagedHomeFeed/SportsHeader/SportList';
import SectionSideBar from '../../../Components/ManagedHomeFeed/SectionSidebar';
import SectionForm from '../../../Components/ManagedHomeFeed/SectionForm';
import VideosTable from '../../../Components/ManagedHomeFeed/Videos';
import useManagedHomeFeed from '../../../customHooks/ManagedHomeFeeds/useManagedHomeFeed';
import useManagedHomeFeedStore from '../../../Store/useManagedHomeFeedStore';
import { CustomButton } from '../../../UI/UIElements/CustomButton';
import FullScreenDialog from '../../../Components/ManagedHomeFeed/FullScreenDialogWrapper';
import AddVideoDialogPage from '../../../Components/ManagedHomeFeed/AddVideoDialog';
import PlayersTable from '../../../Components/ManagedHomeFeed/Players';
import EventsTable from '../../../Components/ManagedHomeFeed/Events';
import AthleteSearch from '../AthleteManagement/AthleteSearch/AthleteSearch';
import EventsSearch from '../EventsManagement/EventsSearch';
import { CONSTANTS } from './types';
import EmptyCard from '../../../Components/Common/EmptyCard';
import { FeedType } from '../../../API/ManagedHomeFeed/types';

function ManagedHomeFeed({ feedType }: { feedType: FeedType }) {
  const {
    selectedCategory,
    selectedSectionKey,
    managedHomeFeed,
    searchOpen,
    setSearchOpen,
    setSelectedSectionKey,
  } = useManagedHomeFeedStore();
  const { isLoading } = useManagedHomeFeed(selectedCategory, feedType);

  const renderAddCTA = () => {
    if (!selectedSectionKey) return null;

    if (selectedSectionKey === CONSTANTS.DEFAULT_REPLAY_SECTION) return null;

    const sectionType =
      managedHomeFeed?.section_data[selectedSectionKey].section_type;

    return (
      <CustomButton
        color="blue"
        style={{
          width: 'fit-content',
          whiteSpace: 'nowrap',
          padding: '5px 15px',
        }}
        onClick={() => setSearchOpen(true)}
      >
        {sectionType === 'long_content' && '+ Add Video'}
        {sectionType === 'player' && '+ Add Player'}
        {sectionType === 'event' && '+ Add Event'}
      </CustomButton>
    );
  };

  useEffect(() => {
    setSelectedSectionKey('');
  }, [feedType]);

  const getSection = () => {
    return managedHomeFeed?.section_data?.[selectedSectionKey];
  };

  const getDialogTitle = () => {
    if (getSection()?.section_type === 'event')
      return `Add Event In ${getSection()?.eng} Section`;

    if (getSection()?.section_type === 'player')
      return `Add Player In ${getSection()?.eng} Section`;

    if (getSection()?.section_type === 'long_content')
      return `Add Video In ${getSection()?.eng} Section`;

    return '';
  };

  return (
    <Box>
      {isLoading && <LinearProgress color="secondary" />}
      <Box
        p={3}
        style={{
          opacity: isLoading ? 0.5 : 1,
          pointerEvents: isLoading ? 'none' : 'all',
        }}
      >
        <Box
          pl={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <SportList feedType={feedType} />

          {renderAddCTA()}
        </Box>

        <Grid container spacing={2} style={{ marginTop: 15 }}>
          <Grid item xs={12} md={3}>
            <SectionSideBar feedType={feedType} />
          </Grid>
          <Grid item xs={12} md={9}>
            {selectedSectionKey != CONSTANTS.DEFAULT_REPLAY_SECTION && (
              <SectionForm />
            )}

            {selectedSectionKey != CONSTANTS.DEFAULT_REPLAY_SECTION && (
              <Box mt={2}>
                {getSection()?.section_type === 'long_content' && (
                  <VideosTable />
                )}

                {getSection()?.section_type === 'player' && <PlayersTable />}

                {getSection()?.section_type === 'event' && <EventsTable />}
              </Box>
            )}

            {selectedSectionKey === CONSTANTS.DEFAULT_REPLAY_SECTION && (
              <EmptyCard
                label={`This is a pre-defined / auto-generated section and cant be edited`}
              />
            )}
          </Grid>
        </Grid>

        <FullScreenDialog
          title={getDialogTitle()}
          open={searchOpen}
          setOpen={setSearchOpen}
          onSubmit={() => {}}
        >
          {getSection()?.section_type === 'long_content' && (
            <AddVideoDialogPage />
          )}

          {getSection()?.section_type === 'player' && (
            <AthleteSearch
              isForManagedHomeFeed
              categoryCode={
                managedHomeFeed?.category_code === 'all_sports'
                  ? ''
                  : managedHomeFeed?.category_code
              }
            />
          )}

          {getSection()?.section_type === 'event' && (
            <EventsSearch
              isForManagedHomeFeed
              categoryCode={
                managedHomeFeed?.category_code === 'all_sports'
                  ? ''
                  : managedHomeFeed?.category_code
              }
            />
          )}
        </FullScreenDialog>
      </Box>
    </Box>
  );
}

export default ManagedHomeFeed;
